import { StoreBrandFilterState } from 'common/types/state'
import { StateKey } from 'common/utils/flipState'
import { SubVertical, Vertical } from 'common/constants'
import { fetchPersonalStoreBrands } from 'common/services/storeBrandFilter'
import { StoreBrandFilterType } from 'common/constants/personalization/storeBrandFilter'

const initialState: StoreBrandFilterState = {
  subVertical: null,
  zzimsIds: [],
  selectedId: null,
  selectedType: null,
  personalizedStoreBrand: null,
}

const FETCH_PERSONALIZED_STORE_BRAND = '/personalized/STORE_BRAND/FETCH'
const SET = '/personalized/STORE_BRAND/SET'
const SET_TYPE = '/personalized/STORE_BRAND/SET_TYPE'
const SET_STORE_BRAND = '/personalized/STORE_BRAND/SET_STORE_BRAND'

export const fetchPersonalizationStoreBrand = (
  curState: StateKey,
  vertical: Vertical,
  subVertical: SubVertical,
  paramMenuId?: string,
  headers?: any,
  action?: string,
) => async (dispatch, getState) => {
  let result: StoreBrandFilterState
  if (action === 'POP') {
    result = getState().storeBrandFilter[curState]
    if (!result.personalizedStoreBrand || result.subVertical !== subVertical) {
      result = await fetchPersonalStoreBrands(vertical, subVertical, paramMenuId, headers)
    }
  } else {
    result = await fetchPersonalStoreBrands(vertical, subVertical, paramMenuId, headers)
  }
  dispatch({
    curState,
    result,
    type: FETCH_PERSONALIZED_STORE_BRAND,
  })
}

export const setSelectedId = (curState: StateKey, selectedId: string) => {
  return {
    curState,
    selectedId,
    type: SET,
  }
}

export const setSelectedFilterType = (curState: StateKey, selectedType: StoreBrandFilterType) => {
  return {
    curState,
    selectedType,
    type: SET_TYPE,
  }
}

export const setPersonalizationStoreBrand = (curState: StateKey, result: StoreBrandFilterState) => {
  return {
    curState,
    result,
    type: SET_STORE_BRAND,
  }
}

const StoreBrandFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PERSONALIZED_STORE_BRAND:
      return {
        ...state,
        ...action.result,
      }
    case SET:
      return {
        ...state,
        selectedId: action.selectedId,
      }
    case SET_TYPE:
      return {
        ...state,
        selectedType: action.selectedType,
      }
    case SET_STORE_BRAND:
      return {
        ...state,
        ...action.result,
      }
    default:
      return state
  }
}

export default StoreBrandFilterReducer
